import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {TimecardStatus} from "../../model";

const MAPPINGS = {
  [TimecardStatus.Approved]: 'timecard-status.approved',
  [TimecardStatus.Disputed]: 'timecard-status.disputed',
  [TimecardStatus.Draft]: 'timecard-status.draft',
  [TimecardStatus.Signed]: 'timecard-status.signed',
  [TimecardStatus.Submitted]: 'timecard-status.submitted'
};

@Pipe({name: 'timecardStatus'})
export class TimecardStatusPipe implements PipeTransform {

  constructor(private Translate: TranslateService) {
  }

  transform(statusId: number): string {
    return this.Translate.instant(MAPPINGS[statusId]);
  }
}
